import { Injectable, EventEmitter } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WizardStepperService {
	onStepChanged = new EventEmitter<{ step: number }>(true);

	private currentStep = 0;

	setCurrentStep(value: number) {
		this.currentStep = value;
	}

	getCurrentStep() {
		return this.currentStep;
	}
}
